import Reward from './src/main';

/* istanbul ignore next */
Reward.install = function(Vue) {
  Vue.component(Reward.name, Reward);
};

export default Reward;
